import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import consortiumBg from "../../assets/images/produtos/consorcio.webp";

const Consortium = () => {
  const serviceData = {
    heroImage: consortiumBg,
    title: "Consórcio",
    subtitle:
      "Conquiste seu automóvel, imóvel ou moto com parcelas que cabem no seu bolso, sem juros",
    color: "yellow",
    icon: "home",
    mainContent: [
      "O consórcio é uma forma inteligente e planejada de adquirir bens como automóveis, imóveis e motos, sem os juros de um financiamento tradicional. Com um consórcio da Free Market Seguros, você pode realizar seus sonhos com parcelas que cabem no seu orçamento.",
      "Trabalhamos com as principais administradoras de consórcio do mercado para oferecer a você as melhores opções de planos, com diferentes prazos e valores, garantindo a solução ideal para seus objetivos de aquisição.",
    ],
    coverages: [
      "Consórcio de automóveis",
      "Consórcio de imóveis",
      "Consórcio de motos",
      "Consórcio de serviços",
      "Consórcio de eletroeletrônicos",
    ],
    additionalCoverages: [
      "Flexibilidade no uso do crédito",
      "Possibilidade de lance para contemplação antecipada",
      "Transferência de cota",
      "Diferentes prazos de pagamento",
      "Opções de consórcios empresariais",
    ],
    advantages: [
      {
        icon: "percentage",
        title: "Sem Juros",
        description:
          "Aquisição planejada sem os juros de um financiamento tradicional",
      },
      {
        icon: "money-bill-wave",
        title: "Parcelas Acessíveis",
        description: "Planos com parcelas que cabem no seu orçamento mensal",
      },
      {
        icon: "handshake",
        title: "Flexibilidade",
        description:
          "Diferentes opções de prazos e valores adaptados às suas necessidades",
      },
    ],
    steps: [
      {
        title: "Análise de Objetivos",
        description:
          "Avaliamos seus objetivos de aquisição, prazo desejado e capacidade financeira.",
      },
      {
        title: "Apresentação de Planos",
        description:
          "Apresentamos as melhores opções de administradoras e planos para seu perfil.",
      },
      {
        title: "Adesão Simplificada",
        description:
          "Após escolher o plano ideal, cuidamos de toda a documentação e processo de adesão.",
      },
      {
        title: "Acompanhamento Contínuo",
        description:
          "Oferecemos suporte durante toda a participação no grupo, inclusive no momento da contemplação.",
      },
    ],
    tip: "Ao contratar um consórcio, considere fazer lances para aumentar suas chances de contemplação antecipada. Lances de 30% a 40% do valor do bem geralmente têm boas chances de serem contemplados, dependendo do grupo. Também é importante verificar a reputação da administradora e entender todas as taxas envolvidas antes de aderir a um plano.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default Consortium;
